import { ActionType, createAction } from 'typesafe-actions'

import { ReportType } from '../../../containers/CompanyDetail/Reports'
import { Dictionary } from '../../../utils/types'
import { UmbracoProduct } from '../../../hooks/useUmbracoProducts'
import { ArchiveExportColumn, PdfOpenMode } from '../../../redux/account/reports/types'
import { DomainType, Domain } from '../../domains'

import { AccountReport, DeliveryType, DocumentType, ReportInfo } from './types'

export const AccountReportsActions = {
  fetchData: createAction('ACCOUNT-REPORTS/load-data')<{
    page: number
    pageSize: number
    filter: string
  }>(),
  setData: createAction('ACCOUNT-REPORTS/set-data')<{
    page: number
    totalPages: number
    data: AccountReport[]
  }>(),
  downloadReport: createAction('ACCOUNT-REPORTS/download-report')<{
    customerRequestId: string
    deliveryType: DeliveryType
    documentType: DocumentType
    downloadReportName: string
    pdfOpenMode: PdfOpenMode
  }>(),
  loadReport: createAction('ACCOUNT-REPORTS/load-report')<{
    documentId: string
    tokenId: string
    customerRequestId: string
    pdfDownloadReportName: string
  }>(),
  setReport: createAction('ACCOUNT-REPORTS/set-report')<{
    document: string
    documentId: string
    customerRequestId: string
    pdfDownloadReportName: string
  }>(),
  resetReport: createAction('ACCOUNT-REPORTS/reset-report')<{}>(),
  downloadExport: createAction('ACCOUNT-REPORTS/download-export')<{ exportId: string }>(),
  reportsLoadDetail: createAction('ACCOUNT-REPORTS/reportsLoadDetail')<{ reportId: string; type: ReportType }>(),
  exportReports: createAction('ACCOUNT-REPORTS/export-reports')<{
    columns: ArchiveExportColumn[]
    umbracoProducts: UmbracoProduct[]
    domains: Partial<Record<DomainType, Domain>>
    name: string
  }>(),
  setReportDetail: createAction('ACCOUNT-REPORTS/reportsSetDetail')<{
    reportId: string
    report: ReportInfo
    type: ReportType
  }>(),
  setFilters: createAction('ACCOUNT-REPORTS/set-filters')<Dictionary<any>>(),
  clearFilter: createAction('ACCOUNT-REPORTS/clear-filter')<{ filterKey: string }>()
}

export type AccountReportsActions = ActionType<typeof AccountReportsActions>
